/*
Achtung: must use d3 v3 ex. d3@3.5.8
*/

import React, { Component } from 'react';
import * as d3 from 'd3';
import moment from 'moment';
import '../../styles/gantt.less';
import * as colors from '../../services/colors.js'

import 'jquery-ui/ui/widgets/datepicker';
import $ from 'jquery';
import 'jquery-ui/themes/base/core.css';
import 'jquery-ui/themes/base/theme.css';
import 'jquery-ui/themes/base/datepicker.css';


class Gantt extends Component {
    constructor(props) {
        super(props);
        var self = this;
        var startYear = this.getStartYear(this.props.data);
        this.state = {
            startDay: this.props.startDay,
            endDay: this.props.endDay,
            config: {
                data: this.props.data,
                element: "#ganttChart",
                box_padding: 10,
                metrics: { type: "yearly", year: startYear },
                colorPrimary: colors.playPrimary,
                colorSecondary: colors.postingPrimary,
                colorNeutral: '#f1f1f1',

                onClick: function (data, bar) {
                    if (data.isSelectable === false) {
                        return;
                    }

                    if (data.localParameter5 != '') {
                        for (let i = 0; i < self.state.config.data.length; i++) {
                            self.state.config.data[i].isSelected = false
                        }
                    }

                    data.isSelected = !data.isSelected;
                    let isSelected = data.isSelected;

                    if (isSelected) {
                        data.stroke = 'black';
                        d3.select(bar).select('.Single--Node').style('stroke', data.stroke);
                    }
                    else if (data.isNotStarted){
                        data.stroke = data.color;
                        d3.select(bar).select('.Single--Node').style('stroke', data.stroke);
                    }
                    else {
                        data.stroke = 'transparent';
                        d3.select(bar).select('.Single--Node').style('stroke', data.stroke);
                    }
                    self.setState({
                    });
                },
                onEmptyButtonClick: function () {},
                onAreaClick: function (location) {}
            }
        }

        this.handleOrderLines = this.handleOrderLines.bind(this);
        this.getSelected = this.getSelected.bind(this);
        this.handleUrlSelect = this.handleUrlSelect.bind(this);
        this.setStartDay = this.setStartDay.bind(this);
        this.setEndDay = this.setEndDay.bind(this);
        this.setLines = this.setLines.bind(this);
        this.getSelectedOrderlineObjects = this.getSelectedOrderlineObjects.bind(this);

    }

    componentDidMount() {
        $("#start_date").datepicker({
            dateFormat: "yy-mm-dd",
            onSelect: this.setStartDay
        });
        $("#end_date").datepicker({
            dateFormat: "yy-mm-dd",
            onSelect: this.setEndDay
        });
        this.handleUrlSelect();
        this.ganttChart(this.state.config, this.state.startDay, this.state.endDay);
    }

    componentDidUpdate() {
        this.ganttChart(this.state.config, this.state.startDay, this.state.endDay);
    }

    getStartYear(data) {
        var minYear = null;
        for (var i = 0; i < data.length; i++) {
            if (!minYear) {
                minYear = moment(data[i].periodStart).format('YYYY');
            } else {
                if (moment(data[i].periodStart).format('YYYY') < minYear) {
                    minYear = moment(data[i].periodStart).format('YYYY');
                }
            }

        }
        return minYear;
    }

    ganttChart(config, startDate, endDate) {
        var data = config.data;
        var ELEMENT = d3.select(config.element),
            CHART_WIDTH = ELEMENT.node().offsetWidth,
            CHART_HEIGHT = d3.max([(((data.length - 1) * 50) + 50), 50]),
            PROGRESSBAR_WIDTH = 200,
            PROGRESSBAR_BOUNDARY = 380,
            BUTTON_COLOR = '#15bfd8';

        for (let i = 0; i < data.length; i++) {
            // Add default color if not set
            if (!data[i]["color"]) {
                if (data[i]["type"] === 'play') {
                    data[i]["color"] = this.state.config.colorPrimary;
                }

                else if (data[i]["type"] === 'posting') {
                    data[i]["color"] = this.state.config.colorSecondary;
                }
                else {
                    data[i]["color"] = this.state.colorNeutral;
                }
            }

            // Add prop
            if (data[i].isSelected === undefined) {
                data[i]["isSelected"] = false;
            }

            // Add stroke prop
            if (data[i].isSelected) {
                data[i]["stroke"] = "black";
            }
            else if (data[i].isNotStarted){
                data[i]["stroke"] = data[i].color;
            }
            else {
                data[i]["stroke"] = "transparent";
            }
        }


        var currentDay = {
            periodStart: moment().startOf('day').toDate(),
            periodEnd: moment().endOf('day').toDate(),
        }

        var startDay = {
            periodStart: moment(startDate),
            periodEnd: moment(startDate)
        }

        var endDay = {
            periodStart: moment(endDate),
            periodEnd: moment(endDate)
        }


        function goToNext() {
            switch (config.metrics.type) {
                case "yearly":
                    config.metrics.year = parseInt(config.metrics.year) + 1; // parseInt due to concat bug on next
                    break;
            }

            draw('next');
        }

        function goToPrevious() {

            switch (config.metrics.type) {
                case "yearly":
                    config.metrics.year = parseInt(config.metrics.year) - 1; // parseInt due to concat bug on next
                    break;
            }
            draw('previous');
        }

        draw('initial');


        function draw(state) {
            var date_boundary = [];
            var subheader_ranges = [];
            var months = [];
            var header_ranges = [];

            d3.select(config.element).node().innerHTML = "";

            if (config.metrics.type == "yearly") {
                months = getMonthsOftheYear(config.metrics.year);
                subheader_ranges = getMonthsRange(months);
                header_ranges = [getYearBoundary(config.metrics.year)];
            }

            date_boundary[0] = moment(months[0], 'MMM YYYY').startOf('month').toDate();
            date_boundary[1] = moment(months[months.length - 1], 'MMM YYYY').endOf('month').toDate();

            var margin = { top: 0, right: 0, bottom: 0, left: 0 },
                width = d3.max([CHART_WIDTH, 400]) - margin.left - margin.right,
                height = CHART_HEIGHT - margin.top - margin.bottom;

            var x = d3.scaleTime()
                .domain(date_boundary)
                .range([0, width]);

            var y = d3.scaleBand()
                .range([0, height * 0.9])
                .padding(0.2);

            y.domain(data.map(function (d, i) {
                return i + 1;
            }));

            var xAxis = d3.axisBottom(x)
                .tickFormat(d3.timeFormat("%d/%m/%Y"));

            var yAxis = d3.axisLeft(y)
                .tickSize(0)
                .tickPadding(6);

            var first_section = ELEMENT
                .append('div')
                .attr('class', 'first_section')
                .style("height", 40)
                .append("svg")
                .attr("width", width + margin.left + margin.right)
                .attr("height", 40)
                .append('g')

            var second_section = ELEMENT
                .append('div')
                .attr('class', 'second_section')
                .style("height", 40)
                .append("svg")
                .attr("width", width + margin.left + margin.right)
                .attr("height", 40)
                .append('g')

            switch (state) {
                case 'initial':
                    first_section
                        .attr("transform", "translate( " + margin.left + ", 30)")
                    second_section
                        .attr("transform", "translate( " + margin.left + ", 0)")
                    break;

                case 'next':
                    second_section
                        .attr("transform", "translate(1000, 0)")
                        .transition()
                        .duration(750)
                        .attr("transform", "translate(" + margin.left + ", 0)");
                    first_section
                        .attr("transform", "translate( 1000, 30)")
                        .transition()
                        .attr("transform", "translate( " + margin.left + ", 30)")
                    break;

                case 'previous':
                    second_section
                        .attr("transform", "translate( -1000, 0)")
                        .transition()
                        .attr("transform", "translate( " + margin.left + ", 0)")
                    first_section
                        .attr("transform", "translate( -1000, 30)")
                        .transition()
                        .attr("transform", "translate( " + margin.left + ", 30)")
                    break;
            }

            var DRAWAREA = ELEMENT
                .append('div')
                .attr('class', 'draw_area')
                .append("svg")
                .attr('class', 'DRAWAREA')
                .attr("width", width + margin.left + margin.right)
                .attr("height", height)

            var svg = DRAWAREA
                .append("g")
                .attr("transform", "translate(" + margin.left + "," + 0 + ")")

            var currentDayArea = svg.append('line')
                .attr('width', getActualWidth(currentDay))
                .attr('class', 'CurrentDay-Area')
                .attr("x1", x(new Date(currentDay.periodStart)))
                .attr("x2", x(new Date(currentDay.periodStart)))
                .attr("y1", 0)
                .attr("y2", height)

            if (startDate) {
                var startDayArea = svg.append('line')
                    .attr('width', getActualWidth(startDay))
                    .attr('class', 'startDay-Area')
                    .attr("x1", x(new Date(startDay.periodStart)))
                    .attr("x2", x(new Date(startDay.periodStart)))
                    .attr("y1", 0)
                    .attr("y2", height)
            }

            if (endDate) {
                var endDayArea = svg.append('line')
                    .attr('width', getActualWidth(endDay))
                    .attr('class', 'endDay-Area')
                    .attr("x1", x(new Date(endDay.periodStart)))
                    .attr("x2", x(new Date(endDay.periodStart)))
                    .attr("y1", 0)
                    .attr("y2", height)
            }

            var leftClickableArea = first_section.append('rect')
                .attr('width', 50)
                .attr('height', 25)
                .attr("y", - 15)
                .attr('fill', '#fff')
                .style("stroke", "#ccc")
                .attr("stroke-width", 1)
                .style("cursor", "pointer")
                .on('click', function () {
                    goToPrevious();
                    config.onAreaClick('left');
                })

            leftClickableArea =
                first_section.append("text").text(String.fromCharCode(0x2190))
                    .attr("fill", "black")
                    .attr("y", 5)
                    .attr("transform", "translate(15)")
                    .style("font-size", "20px")
                    .style("cursor", "pointer")
                    .on('click', function () {
                        goToPrevious();
                        config.onAreaClick('left');
                    })

            var rightClickableArea = first_section.append('rect')
                .attr('width', 50)
                .attr("transform", "translate(" + ((width) - 50) + ")")
                .attr('height', 25)
                .attr("y", - 15)
                .attr('fill', '#fff')
                .style("stroke", "#ccc")
                .attr("stroke-width", 1)
                .style("cursor", "pointer")
                .on('click', function () {
                    goToNext();
                    config.onAreaClick('right');
                })

            rightClickableArea =
                first_section.append("text").text(String.fromCharCode(0x2192))
                    .attr("fill", "black")
                    .attr("y", 5)
                    .attr("transform", "translate(" + (width - 35) + ")")
                    .style("font-size", "20px")
                    .style("cursor", "pointer")
                    .attr("stroke-width", 1)
                    .on('click', function () {
                        goToNext();
                        config.onAreaClick('right');
                    })

            first_section.selectAll(".bar")
                .data(header_ranges)
                .enter().append("text")
                .attr('class', 'first-title')
                .attr('y', - 5)
                .attr("x", function (d) {
                    return x(new Date(d.periodStart)) + (getWidth(d) / 2);
                })
                .attr("width", function (d) {
                    return getWidth(d);
                })
                .attr("height", y.bandwidth())
                .text(function (d) {
                    return d.name
                });

            second_section
                .append("rect")
                .attr("x", x(new Date(date_boundary[0])))
                .attr("width", Math.abs(x(new Date(date_boundary[0])) - x(new Date(date_boundary[1]))))
                .attr("height", 40)
                .attr('class', 'Date-Block-Outline');


            second_section
                .append('g')
                .selectAll(".bar")
                .data(subheader_ranges)
                .enter()
                .append("rect")
                .attr("x", function (d) {
                    return x(new Date(d.periodStart))
                })
                .attr("width", function (d) {
                    return getWidth(d);
                })
                .attr("height", 40)
                .attr('class', function (d) {
                    return "Date-Block Date-" + moment(d.periodStart).format("MMYYYY")
                });

            second_section
                .append('g')
                .selectAll(".bar")
                .data(subheader_ranges)
                .enter().append("text")
                .attr("x", function (d) {
                    return (x(new Date(d.periodStart)) + 10);
                })
                .attr("width", function (d) {
                    return getWidth(d);
                })
                .attr('y', 25)
                .text(function (d) {
                    return d.name.substring(0, 3);
                })
                .attr('class', function (d) {
                    return "second-title Date Date-" + moment(d).format("MMYYYY")
                });


            var bars = svg.append('g').attr("transform", "translate(0, 20)")

            var Blocks = bars.selectAll(".bar")
                .data(data)
                .enter()
                .append("g")
                .attr('class', 'Single--Block cp')
                .attr("transform", function (d, i) {
                    return "translate(" + x(new Date(d.periodStart)) + "," + 0 + ")";
                })
                .call(appendBar)

            Blocks
                .append('g')
                .attr('transform', function (d) {
                    if (startsBefore(d) && isVisible(d)) {
                        var position = Math.abs(x(new Date(d.periodStart)));
                        return "translate(" + position + ", 0)";
                    } else {
                        return "translate(0, 0)";
                    }
                })
                .call(appendTitle)

            Blocks
                .on('click', function (event, d) {
                    config.onClick(d, this);
                });

            function appendBar(selection) {
                selection.append('rect')
                    .attr('class', 'Single--Node')
                    // .attr('rx', 5)
                    // .attr('ry', 5)
                    .attr("height", 15)
                    .attr("fill",
                        function (d, i) {
                            if (d.isNotStarted) {
                                return "transparent";
                            }
                            else if (!d.isComplete) {
                                if (d.type === 'play') {
                                    return "url(#patternDiagonalLinesPlay)";
                                } else {
                                    return "url(#patternDiagonalLinesPosting)";
                                }
                            } else {
                                if (d.color)
                                    return d.color;
                                else
                                    return "#f1f1f1";
                            }
                        })
                    .attr("x", 0)
                    .attr("y",
                        function (d, i) {
                            return y(i + 1);
                        })
                    .attr("width",
                        function (d) {
                            return (getActualWidth(d) + 10);
                        })
                    .attr("stroke",
                        function (d) {
                            return d.stroke;
                        })
                    .style("stroke-width",
                        function (d,i) {
                            if (!d.isSelected) {
                                return 1;
                            } else {
                                return 3;
                            }
                        }).append('title').text(function (d) {
                            return 'Orderline ' + d.id;
                        });
            }

            function appendTitle(selection) {
                selection.append('text')
                    .attr('class', 'Title')
                    .attr("x", 0)
                    .attr("y", function (d, i) {
                        return (y(i + 1) - 3)
                    })
                    .text(function (d) {
                        return d.name + ' - W' + moment(d.periodStart).format('W') + ' - ' + moment(d.periodEnd).format('W');
                    })
            }

            function getWidth(node) {
                if (endsAfter(node)) {
                    width = Math.abs(x(new Date(date_boundary[1])) - x(new Date(node.periodStart)));
                } else if (startsBefore(node)) {
                    width = Math.abs(x(new Date(date_boundary[0])) - x(new Date(node.periodEnd)));
                } else {
                    width = getActualWidth(node);
                }
                return width;
            }

            function getActualWidth(node) {
                return Math.abs(x(new Date(node.periodEnd)) - x(new Date(node.periodStart)));
            }

            function startsBefore(node) {
                return moment(node.periodStart, "MM/DD/YYYY").isBefore(date_boundary[0])
            }

            function endsAfter(node) {
                return moment(node.periodEnd, "MM/DD/YYYY").isAfter(date_boundary[1]);
            }

            function isVisible(node) {
                var periodStart_visible = moment(node.periodStart, "MM/DD/YYYY").isBetween(date_boundary[0], date_boundary[1], 'days'),
                    periodEnd_visible = moment(node.periodEnd, "MM/DD/YYYY").isBetween(date_boundary[0], date_boundary[1], 'days');

                return periodStart_visible || periodEnd_visible;
            }

            function getDaysRange(months) {
                let ranges = [];
                months.map(function (month) {
                    var startOfMonth = moment(month, 'MMM YYYY').startOf('month')
                    var endOfMonth = moment(month, 'MMM YYYY').endOf('month')
                    var day = startOfMonth;

                    while (day <= endOfMonth) {
                        ranges.push({
                            name: moment(day).format('DD'),
                            periodStart: day.toDate(),
                            periodEnd: day.clone().add(1, 'd').toDate(),
                        });
                        day = day.clone().add(1, 'd');
                    }
                });
                return ranges;
            }

            function getMonthsRange(months) {
                let ranges = [];
                months.map(function (month) {
                    var startOfMonth = moment(month, 'MMM YYYY').startOf('month')
                    var endOfMonth = moment(month, 'MMM YYYY').endOf('month')

                    ranges.push({
                        name: moment(startOfMonth).format('MMMM'),
                        periodStart: startOfMonth.toDate(),
                        periodEnd: endOfMonth.clone().add(1, 'd').toDate(),
                    });
                });

                return ranges;
            }

            function getYearBoundary(year) {
                var yearDate = moment(year, 'YYYY');
                let startOfYear = moment(yearDate).startOf('year');
                let endOfYear = moment(yearDate).endOf('year');

                return {
                    name: year,
                    periodStart: startOfYear.toDate(),
                    periodEnd: endOfYear.toDate(),
                };
            }

            function getMonthsOftheYear(year) {
                var months = moment.months();
                months = months.map(function (month) {
                    month = month + " " + year;
                    return month;
                });
                return months;
            }
        }
    }

    // Load data for selected order lines
    handleOrderLines() {
        if (this.state.startDay && this.state.endDay || !this.state.startDay && !this.state.endDay) {
            this.props.onLoadOrderLines(this.getSelected(), this.state.startDay, this.state.endDay);
            this.ganttChart(this.state.config, this.state.startDay, this.state.endDay);
        }
        else {
            alert("Date must have start and end or neither");
        }
    }

    handleUrlSelect() {
        let data = this.state.config.data;
        for (let i = 0; i < data.length; i++) {
            if (this.props.selectedOrderLineIds.indexOf(data[i].id) !== -1) {
                if (data[i].isSelectable) {
                    data[i].isSelected = true;
                }
            }
        }
    }

    getSelected() {
        let data = this.state.config.data;
        let selected = [];
        for (let i = 0; i < data.length; i++) {
            if (data[i].isSelected) {
                selected.push(data[i].id);
            }
        }
        return selected;
    }

    getSelectedOrderlineObjects() {
        let data = this.state.config.data;
        let selected = [];
        for (let i = 0; i < data.length; i++) {
            if (data[i].isSelected) {
                selected.push(data[i]);
            }
        }
        return selected;
    }

    setStartDay(e) {
        const val = e.target ? e.target.value : e;
        this.state.startDay = val;
        if (Date.parse(val)) {
            this.setLines();
        }
        this.setState({
            startDay: val
        });
    }

    setEndDay(e) {
        const val = e.target ? e.target.value : e;
        this.state.endDay = val;
        if (Date.parse(val)) {
            this.setLines();
        }
        this.setState({
            endDay: val
        });
    }

    setLines() {
        this.ganttChart(this.state.config, this.state.startDay, this.state.endDay);
    }

    render() {
        let orderlines = this.getSelectedOrderlineObjects();
        let nofPostingsSelected = orderlines.filter(o => o.type === 'posting').length;
        let notStartedAndStartedSelected = orderlines.filter(o => o.isNotStarted).length > 0 && orderlines.filter(o => !o.isNotStarted).length > 0;
        let nofPlaysSelected = orderlines.filter(o => o.type !== 'posting').length;
        let loadButtonDisabled = orderlines.length === 0
            || nofPostingsSelected > 1
            || notStartedAndStartedSelected
            || (nofPlaysSelected > 0 && nofPostingsSelected > 0);

        return (
            <div>
                <svg height="10" width="10" xmlns="http://www.w3.org/2000/svg" version="1.1">
                    <defs>
                        <pattern id="patternDiagonalLinesPlay" width="4" height="8" patternUnits="userSpaceOnUse" patternTransform="rotate(45)">
                            <rect width="2" height="8" transform="translate(0,0)" fill={colors.playPrimary}></rect>
                        </pattern>
                    </defs>
                    <defs>
                        <pattern id="patternDiagonalLinesPosting" width="4" height="8" patternUnits="userSpaceOnUse" patternTransform="rotate(45)">
                            <rect width="2" height="8" transform="translate(0,0)" fill={colors.postingPrimary}></rect>
                        </pattern>
                    </defs>
                </svg>
                <div className={this.props.expanded ? 'ganttChartHolder ganttChartHolder--exp' : 'ganttChartHolder'}>
                    <label>Select the campaigns to view data for. The report can be limited to a specific period by selecting Start and End dates.</label>
                    <div id="ganttChart" className="ganttChart"></div>
                    <div className="ganttDate">
                        <div className="ganttDate__col">
                            <label>Start</label>
                            <input className="ganttDate__datepicker" id="start_date" value={this.state.startDay} onChange={this.setStartDay} />
                        </div>
                        <div className="ganttDate__col">
                            <label>End</label>
                            <input className="ganttDate__datepicker" id="end_date" value={this.state.endDay} onChange={this.setEndDay} />
                        </div>
                        <div className="ganttDate__col">
                            <button className="btn btn-primary ganttChart__btn" disabled={loadButtonDisabled} onClick={this.handleOrderLines}>Load selected</button>
                        </div>
                        {nofPostingsSelected > 1 && !notStartedAndStartedSelected &&
                        <div>
                            <label>Only one Posting orderline can be selected for a report.</label>
                        </div>
                        }
                        {notStartedAndStartedSelected &&
                        <div>
                            <label>Not possible to select both started and not started orderlines for a report.</label>
                        </div>
                        }
                        {nofPostingsSelected > 0 && nofPlaysSelected > 0 &&
                        <div>
                            <label>Not possible to combine both play and posting orderlines for a report.</label>
                        </div>
                        }
                    </div>
                    { /* Debugging
            <button onClick={this.getSelected}>Get selected</button>
            <button onClick={this.handleUrlSelect}>Select from url</button>
            */
                    }
                </div>
            </div>

        );
    }
}

export default Gantt;
